// import React from 'react';
import {
  TabsV1 as AdobeTabsV1,
  TabsV1Properties
} from "@adobe/aem-core-components-react-spa";
import React from "react";

// Define the props for our AEM Tabs component.
// AdobeTabsV1Props includes all necessary properties like cqItems, cqItemsOrder, isInEditor, etc.
export interface AEMTabsComponentProps extends TabsV1Properties {
  // You can add any additional custom props here if needed in the future
}

const AEMTabsComponent: React.FC<AEMTabsComponentProps> = props => {
  // Render the Adobe TabsV1 component, passing all props.
  // AdobeTabsV1 handles its own editing capabilities, child rendering, and placeholder.
  return (
    <div
      className={`
          [&>div]:mb-8 
          [&>div]:flex
          [&>div]:flex-col 
          [&>div]:items-center
     
          [&_div:has(.placeholder)]:mt-2.5 
          [&_div:has(.placeholder)]:border 
          [&_div:has(.placeholder)]:border-dashed
          [&_div:has(.placeholder)]:border-gray-300
          
          [&_div:has(.placeholder)]:p-5 
          [&_div:has(.placeholder)]:text-center 
          [&_div:has(.placeholder)]:text-gray-500 
          [&_div[role='tabpanel']]:pt-4

          [&_li[role='tab']:hover]:opacity-60 
          [&_li[role='tab'][tabindex='0']]:border-b-black 
          [&_li[role='tab']]:-mb-px 
          [&_li[role='tab']]:flex-1 
          [&_li[role='tab']]:cursor-pointer
          [&_li[role='tab']]:rounded-t-md
          [&_li[role='tab']]:border-2 
          [&_li[role='tab']]:border-transparent 
          [&_li[role='tab']]:px-4
          [&_li[role='tab']]:font-primary-rhsans
          [&_li[role='tab']]:font-extralight
          [&_li[role='tab']]:transition-all

          [&_li[role='tab']]:duration-300
          [&_li[role='tab']]:ease-in-out 
          [&_ol[role='tablist']]:m-0 
          [&_ol[role='tablist']]:flex 
          [&_ol[role='tablist']]:w-full 
          [&_ol[role='tablist']]:list-none
          [&_ol[role='tablist']]:justify-center

          [&_ol[role='tablist']]:border-b
          [&_ol[role='tablist']]:border-b-gray-500 
          [&_ol[role='tablist']]:p-0
          
          [&_ol[role='tablist']]:text-center 
          [&_ol[role='tablist']]:text-[11px]
          [&_ol[role='tablist']]:tracking-[1px]
          
          `}
    >
      <AdobeTabsV1 {...props} />
    </div>
  );
};

export default AEMTabsComponent;
